import { render, staticRenderFns } from "./Persetujuannominee.vue?vue&type=template&id=2f51402b"
import script from "./Persetujuannominee.vue?vue&type=script&lang=js"
export * from "./Persetujuannominee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports